var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6297 19.3805H42.3068V21.7033H44.6297V19.3805Z",
    fill: "#4AA851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3068 17.0576H39.984V19.3804H42.3068V17.0576Z",
    fill: "#4AA851"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 14.7349H37.6612V17.0577H39.984V14.7349Z",
    fill: "#4AA851"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6612 12.412H35.3384V14.7348H37.6612V12.412Z",
    fill: "#4AA851"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3384 10.0264H33.0155V12.3492H35.3384V10.0264Z",
    fill: "#4AA851"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6299 7.70356V5.38074H28.3071V7.70356V10.0264H30.6299H33.0155V7.70356H30.6299Z",
    fill: "#4AA851"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9843 12.412H23.6614V14.7348H21.3386V17.0576H19.0158H16.6302V19.3805H19.0158H21.3386H23.6614V17.0576H25.9843V14.7348H28.3071V12.412V10.0264H25.9843V12.412Z",
    fill: "#4AA851"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27608 24.089H4.95325V26.4118H7.27608V24.089Z",
    fill: "#4AA851"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63042 28.7346V31.0574H4.95325V28.7346V26.4117H2.63042V28.7346Z",
    fill: "#4AA851"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3381 21.7034H47.0153V24.0262H49.3381V21.7034Z",
    fill: "#323232"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0153 24.089H44.6924V26.4118H47.0153V24.089Z",
    fill: "#323232"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0153 19.3805H44.6924V21.7033H47.0153V19.3805Z",
    fill: "#323232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6297 26.4117H42.3068V28.7346H44.6297V26.4117Z",
    fill: "#323232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6297 17.0576H42.3068V19.3804H44.6297V17.0576Z",
    fill: "#323232"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3068 28.7346H39.984V31.0574H42.3068V28.7346Z",
    fill: "#323232"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3068 14.7349H39.984V17.0577H42.3068V14.7349Z",
    fill: "#323232"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 31.0574H37.6612V33.3802H39.984V31.0574Z",
    fill: "#323232"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 12.412H37.6612V14.7348H39.984V12.412Z",
    fill: "#323232"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6612 33.3802H35.3384V35.7031H37.6612V33.3802Z",
    fill: "#323232"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6612 10.0264H35.3384V12.3492H37.6612V10.0264Z",
    fill: "#323232"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3384 35.7031H33.0155V38.026H35.3384V35.7031Z",
    fill: "#323232"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3384 7.70361H33.0155V10.0264H35.3384V7.70361Z",
    fill: "#323232"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9527 38.0887H30.6299V40.4116H32.9527V38.0887Z",
    fill: "#323232"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9527 5.38074H30.6299V7.70356H32.9527V5.38074Z",
    fill: "#323232"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6299 40.4115H28.3071V42.7343H30.6299V40.4115Z",
    fill: "#323232"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6299 3.05798H28.3071V5.38081H30.6299V3.05798Z",
    fill: "#323232"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3071 42.7344H25.9843V45.0572H28.3071V42.7344Z",
    fill: "#323232"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3071 0.735107H25.9843V3.05794H28.3071V0.735107Z",
    fill: "#323232"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9843 38.0887V35.7031V33.3802H23.6614V35.7031V38.0887V40.4115V42.7343H25.9843V40.4115V38.0887Z",
    fill: "#323232"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9843 10.0265V7.70364V5.38081V3.05798H23.6614V5.38081V7.70364V10.0265V12.4121H25.9843V10.0265Z",
    fill: "#323232"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3386 31.0574H19.0158H16.6302H14.3073H11.9845H9.66168H7.33885H4.95325H2.63042V33.3802H4.95325H7.33885H9.66168H11.9845H14.3073H16.6302H19.0158H21.3386H23.6614V31.0574H21.3386Z",
    fill: "#323232"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33885 14.7348H9.66168H11.9845H14.3073H16.6302H19.0158H21.3386H23.6614V12.412H21.3386H19.0158H16.6302H14.3073H11.9845H9.66168H7.33885H4.95325H2.63042V14.7348H4.95325H7.33885Z",
    fill: "#323232"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63042 28.7346V26.4118V24.089V21.7033V19.3805V17.0577V14.7349H0.307587V17.0577V19.3805V21.7033V24.089V26.4118V28.7346V31.0574H2.63042V28.7346Z",
    fill: "#323232"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0153 21.7034H44.6924V24.0262H47.0153V21.7034Z",
    fill: "#478443"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6297 24.089H42.3068V26.4118H44.6297V24.089Z",
    fill: "#478443"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3068 26.4117H39.984V28.7346H42.3068V26.4117Z",
    fill: "#478443"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 28.7346H37.6612V31.0574H39.984V28.7346Z",
    fill: "#478443"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6612 31.0574H35.3384V33.3802H37.6612V31.0574Z",
    fill: "#478443"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3384 33.3802H33.0155V35.7031H35.3384V33.3802Z",
    fill: "#478443"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9527 35.7031H30.6299V38.026H32.9527V35.7031Z",
    fill: "#478443"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6299 38.0887H28.3071V40.4116H30.6299V38.0887Z",
    fill: "#478443"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9843 31.0574H23.6614V33.3802H25.9843V31.0574Z",
    fill: "#478443"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3386 31.0574H23.6614V28.7346H21.3386H19.0158H16.6302H14.3073H11.9845H9.66168H7.33885H4.95325V31.0574H7.33885H9.66168H11.9845H14.3073H16.6302H19.0158H21.3386Z",
    fill: "#478443"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 17.0576H37.6612V14.7348H35.3384V12.412H33.0155V10.0264H30.6299V12.412V14.7348H28.3071H25.9843V17.0576H23.6614V19.3805H21.3386H19.0158H16.6302H14.3073H11.9845H9.66168H7.33885V21.7033V24.0889V26.4117H4.95325V28.7346H7.33885H9.66168H11.9845H14.3073H16.6302H19.0158H21.3386H23.6614V31.0574H25.9843V33.3802H28.3071V35.703H30.6299V33.3802H33.0155V31.0574H35.3384V28.7346H37.6612V26.4117H39.984V24.0889H42.3068V21.7033V19.3805H39.984V17.0576Z",
    fill: "#4AA851"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6297 21.7034H42.3068V24.0262H44.6297V21.7034Z",
    fill: "#4AA851"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3068 24.089H39.984V26.4118H42.3068V24.089Z",
    fill: "#4AA851"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 26.4117H37.6612V28.7346H39.984V26.4117Z",
    fill: "#4AA851"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6612 28.7346H35.3384V31.0574H37.6612V28.7346Z",
    fill: "#4AA851"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3384 31.0574H33.0155V33.3802H35.3384V31.0574Z",
    fill: "#4AA851"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9527 33.3802H30.6299V35.7031H32.9527V33.3802Z",
    fill: "#4AA851"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3071 33.3802H25.9843V35.7031V38.0887V40.4115V42.7343H28.3071V40.4115V38.0887H30.6299V35.7031H28.3071V33.3802Z",
    fill: "#4AA851"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3071 7.70364V5.38081V3.05798H25.9843V5.38081V7.70364V10.0265H28.3071V7.70364Z",
    fill: "#80E977"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95325 24.089V21.7033V19.3805V17.0577H7.33885H9.66168H11.9845H14.3073H16.6302H19.0158H21.3386V14.7349H19.0158H16.6302H14.3073H11.9845H9.66168H7.33885H4.95325H2.63042V17.0577V19.3805V21.7033V24.089V26.4118H4.95325V24.089Z",
    fill: "#80E977"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3071 12.412V14.7348H30.6299V12.412V10.0264H28.3071V12.412Z",
    fill: "#6BD063"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3073 19.3804H16.6302V17.0576H14.3073H11.9845H9.66168H7.33885H4.95325V19.3804V21.7033V24.0889H7.33885V21.7033V19.3804H9.66168H11.9845H14.3073Z",
    fill: "#6BD063"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.3fdce6ea231df880b14cff21430f1523.svg";
export { ForwardRef as ReactComponent };